module.exports = __webpack_public_path__ + "preloader-logo.07666bda.png";